import { useNode } from '@craftjs/core';
import { FormCheckboxGroupInputComponent } from 'src/features/generalForms/builder/types/CheckboxGroupInput';
import { FormFieldOption } from 'src/features/generalForms/builder/types/BaseControlTypes';
import { useFormContext } from 'react-hook-form';
import { useFieldState } from 'src/features/generalForms/builder/layout/panels/helpers/expression/useFieldState';
import { useHookFieldErrors } from 'src/helpers/error-helpers';
import { hookFormRules } from '../../../fillingModal/react-hook-form-helper';
import { HookFormCheckboxGroupField } from 'src/features/generalForms/uikit/hookFormFields/hookFormCheckboxGroupField';

export const FormCheckboxGroupInput: FormCheckboxGroupInputComponent = (props) => {
  const { styles } = useNode((node) => ({
    styles: node.data.custom,
  }));
  const form = useFormContext();
  const { paddingBottom, paddingLeft, paddingRight, paddingTop, ...restStyles } = styles;
  const { visible, isDisabled } = useFieldState(form);
  const errors = useHookFieldErrors(props.dataKey!);

  if (!visible) {
    return <></>;
  }

  return (
    <div style={{ paddingBottom, paddingLeft, paddingRight, paddingTop }}>
      <HookFormCheckboxGroupField<FormFieldOption, 'key'>
        style={restStyles}
        control={form.control}
        name={props.dataKey!}
        labelProps={{
          text: props.title,
          isBold: true,
          tooltip: props.tooltip,
          description: props.description,
          isOptional: props.isOptional,
          prefix: props.prefix,
        }}
        valueField={'key'}
        labelField={'value'}
        options={props.options ?? []}
        disabled={isDisabled}
        rules={hookFormRules({
          required: !props.isOptional && !isDisabled,
        })}
        errorProps={{ errors }}
        defaultValue={props.defaultValue}
      />
    </div>
  );
};
